import _ from 'lodash';

export const cookie = {
  findAll(): { [key: string]: string } {
    return _.reduce(
      document.cookie.split(';'),
      (accumulator: { [key: string]: string }, rawCookie: string) => {
        const cookie = rawCookie.replace(/^\s+/, '').replace(/\s+$/, '');
        const [key, value] = cookie.split('=');

        accumulator[key] = value;

        return accumulator;
      },
      {},
    );
  },

  find(name: string): string {
    let cookie = '';
    const list = this.findAll();

    _.forEach(list, (value, key) => {
      if (key === name) {
        cookie = unescape(value);
      }
    });

    return cookie;
  },

  create(name: string, value: string, time: number): void {
    const today = new Date();
    const offset =
      typeof time === 'undefined' ? 1000 * 60 * 60 * 24 : time * 1000;
    const expiresAt = new Date(today.getTime() + offset);

    document.cookie = `${name}=${value};expires=${expiresAt.toUTCString()};path=/`;
  },

  destroy(name: string, cookie: string) {
    if (cookie === this.find(name)) {
      this.create(name, null, -1000000);
    }

    return this;
  },
};
